/* Add your custom JS here. */
console.log('customjs')
var scrollStop = function (callback, _scope) {
    var scope = _scope || window;
    // Make sure a valid callback was provided
    if (!callback || typeof callback !== 'function')
        return;

    // Setup scrolling variable
    var isScrolling;

    // Listen for scroll events
    scope.addEventListener('scroll', function (event) {

        // Clear our timeout throughout the scroll
        window.clearTimeout(isScrolling);

        // Set a timeout to run after scrolling ends
        isScrolling = setTimeout(function() {

            // Run the callback
            callback();

        }, 66);

    }, false);
};

function isInViewport(element, percentViewable) {
    const rect = element.getBoundingClientRect();
    let rectXFactor = 0;
    let rectYFactor = 0;
    if (percentViewable > 0 && percentViewable < 100) {
        let multiplier = percentViewable / 100;
        rectXFactor = rect.height * multiplier;
        rectYFactor = rect.height * multiplier;
    }
    return (
        rect.top >= 0 &&
        rect.left >= 0 &&
        (rect.bottom - rectYFactor) <= (window.innerHeight || document.documentElement.clientHeight) &&
        (rect.right - rectXFactor) <= (window.innerWidth || document.documentElement.clientWidth)
    );
}

function jimTest() {
    alert('hello')
}

var icon = document.getElementById("icon");
var icon1 = document.getElementById("a");
var icon2 = document.getElementById("b");
var icon3 = document.getElementById("c");
var nav = document.getElementById('dcpnav');
//var blue = document.getElementById("blue");

icon.addEventListener('click', function() {
    icon1.classList.toggle('a');
    icon2.classList.toggle('c');
    icon3.classList.toggle('b');
    nav.classList.toggle('show');
    //blue.classList.toggle('slide');
});